import React from 'react';
import {ItemIconSize} from "../../@const";

type CustomIconProps = {
    icon: string
    size: ItemIconSize
    className?: string
};

export default function CustomIcon(props:CustomIconProps) {



    if (!props.icon || !props.icon.startsWith('url:')) {
        return null;
    }

    const url = props.icon.substring(4);

    // @ts-ignore
    const sizePixels : number = parseInt(props.size) || 14

    const style: React.CSSProperties = {
        width: sizePixels,
        height: sizePixels,
        backgroundImage: `url(${url})`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        display: 'inline-block',
        verticalAlign: 'middle',
        flexShrink: 0,
    };


    const classes = Classes('custom-icon-url', props.className)

    return (
        <div
            className={classes}
            style={style}
        />
    );
};


